import React, { useEffect } from "react"
import { AppIconChipToggle } from "@components"
import { reportFormData, useOfficePickup } from "Pages/ReportsAlerts/Reports/@signals"


export default function OfficeSwitch() {


	useEffect(() => {
		useOfficePickup.value = !!reportFormData.peek().idOfficeGroup?.length
	}, [])

	return <AppIconChipToggle
		aria-label="Pick-up by"
		value={!!useOfficePickup.value}
		options={[
			{ value: false, label: 'Offices', icon: 'plane-departure' },
			{ value: true, label: 'Office group', icon: 'layer-group' },
		]}
		onChange={value => useOfficePickup.value = value}
	/>
}